import React from 'react'
import { SvgIcon } from '@mui/material'

export const SaveIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M5 18h4.24a1 1 0 0 0 .71-.29l6.92-6.93L19.71 8a1 1 0 0 0 0-1.42l-4.24-4.29a1 1 0 0 0-1.42 0l-2.82 2.83-6.94 6.93a1 1 0 0 0-.29.71V17a1 1 0 0 0 1 1Zm9.76-13.59 2.83 2.83-1.42 1.42-2.83-2.83 1.42-1.42ZM6 13.17l5.93-5.93 2.83 2.83L8.83 16H6v-2.83ZM21 20H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2Z" />
  </SvgIcon>
)
